import * as actionTypes from '../actions/actionTypes'

export default function reduce(state = {}, action) {
    let isResizingStateLocation, sizeStateLocation, newSize;
    switch(action.type) {
        case actionTypes.START_RESIZE_WINDOW:
            isResizingStateLocation = action.payload.isResizingStateLocation;

            return Object.assign({}, state, {
                [isResizingStateLocation] : true
            });
        case actionTypes.END_RESIZE_WINDOW:
            isResizingStateLocation = action.payload.isResizingStateLocation;
            sizeStateLocation = action.payload.sizeStateLocation;
            newSize = action.payload.size;
            let positionLocation = action.payload.positionLocation;
            let position = action.payload.position;

            return Object.assign({}, state, {
                [isResizingStateLocation] : false,
                [sizeStateLocation] : newSize,
                [positionLocation] : position
            });
    	case actionTypes.SET_WINDOW_SIZE:
    		sizeStateLocation = action.payload.sizeStateLoc;
		    newSize = action.payload.size;

		    return Object.assign({}, state, {
			    [sizeStateLocation]: newSize
		    });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-resize/src/reducers/index.js